/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.RATING = function () {

    this.resourceKey = 'survey.sidebar.rating';
    this.jsonType = 'RATING';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

    var getFieldRating = function () {
        const field = new Monet.UI.Fields.Rating();

        if (Greenmile.Survey.Builder.releasedDate) {
            field.disabled = true;
        }
        return field;
    };

    //This is a callback. You should implemented it if you want show something different of SurveyGenericContainerTemplate.
    this.didRenderTemplate = function (question) {

        var header = document.querySelector('#SurveyLinkForm .SingleRowHeader');

        var field = getFieldRating();
        if (question && question.defaultAnswer) {
            field.setValue(question.defaultAnswer);
        }
        header.appendChild(field.render());
        this.fieldDefaultAnswer = field;
    };

    this.getPreviewContent = function (question) {
        var field           = getFieldRating(),
            ratingContainer = document.createElement('div');

        if (Greenmile.Survey.Builder.releasedDate) {
            field.disabled = true;
        }
        field.setValue(question.defaultAnswer);
        ratingContainer.id = question.id;
        ratingContainer.appendChild(field.render());
        return ratingContainer;

    };

};